import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonProps } from "~/components/ui/button";

// // // //

export function DownloadButton(props: {
    size?: ButtonProps["size"];
    testID?: string;
    disabled: boolean;
    onClick: () => void;
}) {
    const { size = "xs", testID } = props;
    return (
        <Button
            size={size}
            variant="outline"
            className="shadow-sm border-muted-foreground"
            data-testid={testID}
            disabled={props.disabled}
            onClick={() => {
                props.onClick();
            }}
        >
            <FontAwesomeIcon icon={faDownload} aria-hidden="true" />
            Download CSV
        </Button>
    );
}
